import { clsx } from 'clsx'
import { opt } from 'store/opt'
import css from './Loader.module.scss'

export const Loader = () => {
  const className = clsx(css.loader, opt.stand && css.stand)

  return <div className={className}>
    <span /> <span /> <span /> <span />
  </div>
}
